import {
    FETCH_BUILDING_INDICATORS,
    FETCH_BUILDING_INDICATOR_TYPES,
    CREATE_BUILDING_INDICATOR,
    UPDATE_BUILDING_INDICATOR,
    DELETE_BUILDING_INDICATOR,
} from "@/store/actions/building_indicators";
import buildingIndAPI from "@/utils/axios/building_indicator"
import {ALERT_SHOW} from "@/store/actions/alert";
import {START_MODAL_LOADING, STOP_MODAL_LOADING} from "@/store/actions/loading";

const state = { build_indicators: [], build_indicator_status: false, build_indicator_types: [] }

const getters = {
    getBuildingIndicators: state => state.build_indicators,
    getBuildingIndicatorStatus: state => state.build_indicator_status,
    getBuildingIndicatorTypes: state => state.build_indicator_types
}

const actions = {
    [FETCH_BUILDING_INDICATORS]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            buildingIndAPI.all(payload)
                .then(response => response.data)
                .then(data => {
                    commit(FETCH_BUILDING_INDICATORS, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
    [FETCH_BUILDING_INDICATOR_TYPES]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            buildingIndAPI.select()
                .then(response => response.data)
                .then(data => {
                    commit(FETCH_BUILDING_INDICATOR_TYPES, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
    [CREATE_BUILDING_INDICATOR]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            buildingIndAPI.create(payload)
                .then(response => response.data)
                .then(data => {
                    commit(CREATE_BUILDING_INDICATOR, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })

    },
    [UPDATE_BUILDING_INDICATOR]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            buildingIndAPI.update(payload)
                .then(response => response.data)
                .then(data => {
                    commit(UPDATE_BUILDING_INDICATOR, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [DELETE_BUILDING_INDICATOR]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            buildingIndAPI.remove(payload)
                .then(response => response.data)
                .then(data => {
                    commit(DELETE_BUILDING_INDICATOR, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
}

const mutations = {
    [FETCH_BUILDING_INDICATORS]: (state, payload) => {
        state.build_indicators = payload
    },
    [FETCH_BUILDING_INDICATOR_TYPES]: (state, payload) => {
        state.build_indicator_types = payload
    },
    [CREATE_BUILDING_INDICATOR]: (state, payload) => {
        state.build_indicators.push(payload)
    },
    [UPDATE_BUILDING_INDICATOR]: (state, payload) => {
        let obj = state.build_indicators.find(item => item.id === payload.id)
        Object.keys(payload).forEach(item => {
            obj[item] = payload[item]
        })
    },
    [DELETE_BUILDING_INDICATOR]: (state, payload) => {
        const obg = state.build_indicators.find(item => item.id === payload.id)
        const obj_id = state.build_indicators.indexOf(obg)
        if (obg) {
            state.build_indicators.splice(obj_id, 1)
        }
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}